import * as React from 'react';
import rentimeLogo from '../assets/rentime-logo.png';
import testServerLogo from '../assets/test-server.jpeg';
import accountProvider from '../account/AccountProvider';
import {Icon, Layout, Menu, Modal} from 'antd';
import {RouteComponentProps, withRouter} from 'react-router';
import {SelectParam} from 'antd/lib/menu';
import {allowedMenuRoutes, allowedSubMenuRoutes, MenuRoute} from './AppRoutes';
import locales from "../locales";
import './AppSlider.css';
import {alertsPath, checklistAlertsPath, eventAlertsPath, maintenancesPath} from "../paths";
import {CollapseType} from 'antd/lib/layout/Sider';
import ItemAlertBadge from "./alert/ItemAlertBadge";
import ItemMaintenanceAlertBadge from "./alert/ItemMaintenanceAlertBadge";
import EventAlertBadge from "./alert/EventAlertBadge";
import ChecklistAlertBadge from "./alert/ChecklistAlertBadge";
import CompanySelector from '../account/CompanySelector';

const {SubMenu} = Menu;
const {Sider} = Layout;

interface Props extends RouteComponentProps {
  onLogout: () => void;
}

interface State {
  collapsed: boolean;
  smallScreen: boolean
}

class AppSlider extends React.Component<Props, State> {

  public state: State = {
    collapsed: true,
    smallScreen: false
  };

  public render(): React.ReactNode {
    const {collapsed} = this.state;
    const account = accountProvider.getAccountStorage();
    const isLoggedIn = accountProvider.isLoggedIn();

    return (
      <Sider
        id="app-side-menu"
        breakpoint="lg"
        collapsed={collapsed}
        onCollapse={this.onCollapse}
        collapsedWidth={0}
        width={300}
        onBreakpoint={this.onBreakPoint}
        trigger={isLoggedIn ? undefined : null}
      >
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[this.props.location.pathname]}
          onSelect={this.onMenuSelect}
        >
          {isLoggedIn && (
            <div id="account-box">
              <p>{account.userName}</p>
              <p>
                <a onClick={this.showLogoutConfirm}>
                  <Icon type="poweroff" style={{marginRight: 4}}/>{locales.logout}
                </a>
              </p>
            </div>
          )}
          <div className="logo">
            {this.renderLogoImg()}
          </div>
          {isLoggedIn && <CompanySelector key={account.userName}/>}
          {isLoggedIn &&
            allowedMenuRoutes().map(route => this.renderMenuRoute(route))
          }
          {isLoggedIn && <div style={{height: 100}}/>}
        </Menu>
      </Sider>
    );
  }

  private renderLogoImg = (): React.ReactNode => {
    return (
      process.env.REACT_APP_ENV === 'test' ? (
        <img src={testServerLogo} alt="" style={{width: '100%'}}/>
      ) : (
        <img src={rentimeLogo} alt=""/>
      )
    );
  }

  private renderMenuRoute = (route: MenuRoute): React.ReactNode => {
    if (route.subMenus) {
      return this.renderSubMenu(route);
    } else {
      return this.renderMainMenu(route);
    }
  };

  private renderSubMenu = (route: MenuRoute) => {
    const allowedSubMenus = route.subMenus ? allowedSubMenuRoutes(route.subMenus) : [];
    return allowedSubMenus.length > 0 ?
      <SubMenu
        key={route.path}
        title={(
          <span>
                        <Icon type={route.icon}/>
                        <span>{route.name}</span>
                    </span>
        )}
      >
        {allowedSubMenus.map((subRoute) => <Menu.Item
            key={subRoute.path}
          >
            <div>
              <Icon type={subRoute.icon}/>
              {subRoute.name}
            </div>
          </Menu.Item>
        )}
      </SubMenu>
      :
      <></>
  };

  private renderMainMenu = (route: MenuRoute) => {
    return (
      <Menu.Item key={route.path}>
        <Icon type={route.icon}/>
        <span>{route.name}</span>
        {route.path === alertsPath && <ItemAlertBadge/>}
        {route.path === maintenancesPath && <ItemMaintenanceAlertBadge/>}
        {route.path === eventAlertsPath && <EventAlertBadge/>}
        {route.path === checklistAlertsPath && <ChecklistAlertBadge/>}
      </Menu.Item>
    );
  };

  private showLogoutConfirm = () => Modal.confirm({
    title: locales.logout_confirm,
    onOk: this.onLogoutConfirmed,
    okText: locales.yes,
    cancelText: locales.cancel,
  });

  private onLogoutConfirmed = () => {
    const {onLogout} = this.props;
    if (this.isMobileViewAndSidebarOpen()) {
      this.closeSidebarThenCallback(onLogout);
    } else {
      onLogout();
    }
  };

  private onBreakPoint = (broken: boolean) => {
    this.setState({smallScreen: broken, collapsed: broken});
  };

  private onCollapse = (collapsed: boolean, type: CollapseType) => {
    this.setState({collapsed});
  };

  private onMenuSelect = (param: SelectParam) => {
    const path = param.keyPath[0]!!;
    const navigate = () => this.props.history.push(path);

    if (this.isMobileViewAndSidebarOpen()) {
      // We are in "mobile" mode so close sidebar, then navigate
      this.closeSidebarThenCallback(navigate);
    } else {
      // We are in "desktop" mode, just navigate
      navigate();
    }
  };

  private closeSidebarThenCallback = (callback: () => void) => {
    // Collapse animation is over (300ms), then callback
    this.setState({collapsed: true}, () => setTimeout(callback, 300));
  };

  private isMobileViewAndSidebarOpen = (): boolean => {
    const {collapsed, smallScreen} = this.state;
    return smallScreen && !collapsed;
  }
}

export default withRouter(AppSlider);



// WEBPACK FOOTER //
// ./src/app/AppSlider.tsx